<template>
  <div class="container">
    <h3 class="title">Jakiego specjalisty potrzebujesz?</h3>
    <div class="btn-group">
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('hydraulik')">Hydraulik</button>
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('Elektryk')">Elektryk</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('slusarz')">Ślusarz</button>
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('szklarz')">Szklarz</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('dekarz')">Dekarz</button>
      <button type="button" class="btn" :style="{ background: $color }" @click="btnHandler('murarz')">Murarz</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandler('technik')">Tech. urz. grzew.</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "StepHomeSpecialist",
  methods: {
    ...mapMutations(['setUserData', 'setAssistanceStep']),
    btnHandler (SpecialistType) {
      this.setUserData({ SpecialistType })
      this.setAssistanceStep('additional')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepHomeSpecialist.vue